export default __webpack_public_path__ + "static/media/1821.5cdb26c5.png";